import React from "react";
import { ArrowRight, ChevronRight, Phone } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      className="relative section-padding"
      data-testid="final-cta-section"
    >
      <div className="absolute inset-x-6 lg:inset-x-8 inset-y-12 max-w-7xl mx-auto rounded-[2.5rem] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#070707] to-[#0a0a0a]" />
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#39FF14]/12 blur-[160px] rounded-full" />
        <div className="absolute -bottom-32 right-0 w-[500px] h-[500px] bg-[#007AFF]/15 blur-[160px] rounded-full" />
        <div className="absolute inset-0 grid-bg opacity-50" />
        <div className="absolute inset-0 border border-white/8 rounded-[2.5rem] pointer-events-none" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 py-20 text-center reveal">
        <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.3em] text-[#39FF14]">
          <span className="live-dot" />
          Accepting 3 new clients this quarter
        </div>
        <h2 className="mt-6 text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-[1.05]">
          Ready To <span className="gradient-text-green">Scale Smarter?</span>
        </h2>
        <p className="mt-7 text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto leading-relaxed">
          Let's build modern systems that help your business grow faster and
          operate more efficiently.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://cal.com/erik-carlson/secret"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#39FF14] text-black font-semibold hover:bg-white hover:shadow-[0_0_44px_rgba(57,255,20,0.55)] transition-all"
            data-testid="final-cta-primary"
          >
            Book A Strategy Call
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
          </a>
          <a
            href="#services"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/15 text-white font-semibold hover:bg-white/5 hover:border-white/30 transition-all"
            data-testid="final-cta-secondary"
          >
            Explore Solutions
            <ChevronRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
          </a>
        </div>

        <a
          href="tel:2149838371"
          className="mt-10 inline-flex items-center gap-3 text-zinc-400 hover:text-white transition group"
          data-testid="final-cta-phone"
        >
          <Phone className="w-4 h-4 text-[#39FF14]" />
          <span className="text-sm">Or call directly</span>
          <span className="font-mono text-white group-hover:text-[#39FF14] transition">
            214-983-8371
          </span>
        </a>

        <div className="mt-4">
          <a
            href="#contact-form"
            className="text-sm text-zinc-500 hover:text-[#39FF14] transition inline-flex items-center gap-1.5"
            data-testid="final-cta-form-link"
          >
            Prefer to write? Send a message
            <ChevronRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
